module.exports = __webpack_public_path__ + "static/icon-components-b3f1b7e09e3c3ddd8ea12c1df44d5423.svg";